<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório quantitativo de procedimentos">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/ambulatorio/relatorio-quantitativo-procedimento/List'

export default {
    components: { List },
}
</script>